// extracted by mini-css-extract-plugin
export default {"container":"Success_container__cUoXB","content":"Success_content__hC1ML"};